import { render, staticRenderFns } from "./auto-messages-edit.vue?vue&type=template&id=22a05ebf&scoped=true&"
import script from "./auto-messages-edit.vue?vue&type=script&lang=js&"
export * from "./auto-messages-edit.vue?vue&type=script&lang=js&"
import style0 from "./auto-messages-edit.vue?vue&type=style&index=0&id=22a05ebf&prod&lang=sass&scoped=true&"
import style1 from "./auto-messages-edit.vue?vue&type=style&index=1&id=22a05ebf&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a05ebf",
  null
  
)

export default component.exports